import React, { ReactNode, FC, useMemo, LegacyRef, useContext } from 'react';
import { WithTranslation } from 'react-i18next';
import { WithAnalytics } from 'ia-react-core/~/interfaces/WithAnalytics';

import { ThemeContext } from 'styled-components';
import { SCP } from 'ia-react-core/~/interfaces/SCP';
import { ReactComponent as InfoOutlineIcon } from '../../../icons/infoOutline.svg';
import StatusButton from '../StatusButton';

export interface InfoButtonProps extends WithAnalytics, SCP<'button'> {
  /** Accessible label to replace the default one. */
  children?: ReactNode;
  /** @ignore */
  ref?: LegacyRef<HTMLButtonElement>;
}

const InfoButton: FC<InfoButtonProps & WithTranslation> = React.forwardRef<HTMLButtonElement, InfoButtonProps & WithTranslation>(({ t, children, ...props }, ref) => {
  const description = useMemo(() => children as string || t('buttonText'), [children, t]);
  const theme = useContext(ThemeContext);
  return (
    <StatusButton
      label={description}
      Icon={InfoOutlineIcon}
      ref={ref}
      color={theme.colors.info}
      {...props}
    />
  );
});

InfoButton.displayName = 'InfoButton';

export default InfoButton;
